export default __webpack_public_path__ + "static/logo-d8b3ba981ee125613756c6a38e6a3627.svg";